import Player from '@vimeo/player';

const HeroVideo = (element) => {
    const url = element.dataset.url;
    let player;
    if (url) {
        player = new Player('js-hero-video', {
            url: url,
            autoplay: true,
            background: true,
            loop: true,
        });
    } else {
        const iframe = element.querySelector('iframe');
        player = new Player(iframe);
    }

    player.on('play', function() {
        const previewImage = document.querySelector('.js-hero-video-preview');
        previewImage.classList.add('hidden');
    });
};

export default HeroVideo;
